import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() { }

  downloadResume(): void {
    // Create a reference to the file we want to download
    const storage = firebase.storage();
    const gsReference = storage.refFromURL(environment.gsRefpath);
    gsReference.getDownloadURL().then((url) => {
      window.open(url);
    },
    err => console.log(err)
    );
  }

}
